import React from "react";
import "./Timeline.css";
import {
  VerticalTimeline,
  VerticalTimelineElement
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import { IoIosSchool } from "react-icons/io";
import WorkIcon from '@material-ui/icons/Work';
import SchoolIcon from "@material-ui/icons/School";
import StarRateIcon from "@material-ui/icons/StarRate";
import { ThemeContext } from "../../Context/theme";
import { Box } from "@material-ui/core";

export const Timeline = () => {
  const [{ themename }] = React.useContext(ThemeContext);
  const [linecolor, setlinecolor] = React.useState(
    themename === "light" ? "#23283e" : "#fcfcfc"
  );

  React.useEffect(() => {
    if (themename === "dark") {
      setlinecolor("#fcfcfc");
    } else {
      setlinecolor("#23283e");
    }
  }, [themename]);
  return (
    <>
      <div className="section mainsection">
        <h2 className="section__title" data-aos="fade-right">
          My <span className="different">Timeline 💫</span>
        </h2>
        <VerticalTimeline lineColor={linecolor}>

          {/* /////////////// work///////////////////////// */}

          <VerticalTimelineElement
            // date={"Jun 2023 - Aug 2023"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
              border: `solid rgb(236, 240, 236) 1px`,
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`
            }}
            icon={<WorkIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Full Stack Developer
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              RemitBee Ind Pvt Ltd
            </h4>
            <p className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
              id="Course">
              Aug 2023 - Present
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            // date={"Jun 2023 - Aug 2023"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`,
              border: `solid rgb(236, 240, 236) 1px`,
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`
            }}
            icon={<WorkIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Frontend Developer (Internship)
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Pinak Idea Lab Pvt Ltd
            </h4>
            <p className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
              id="Course">
              Jun 2023 - Aug 2023
            </p>
          </VerticalTimelineElement>

          {/* <VerticalTimelineElement
            // date={"April 2022 - Present"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Student
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              Masai School (Remote)
            </h4>
            <h4 
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
              id="Course"
              > April 2022 - Feb 2023 </h4>

          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            // date={"2015 - 2018"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Bachelor of Science, Mathematics Honors
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              D B College, Jainagar
            </h4>

            <h4 
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
              id="Course"
              > 2015 - 2018 </h4>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            // date={"March 2015"}
            contentStyle={{
              boxShadow: `var(--shadow)`,
              backgroundColor: `var(--clr-bg)`,
              textAlign: "center",
              color: `var(--clr-fg-alt)`
            }}
            contentArrowStyle={{ borderRight: "16px solid  rgb(33, 150, 243)" }}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`
            }}
            icon={<SchoolIcon />}
          >
            <h3
              className="vertical-timeline-element-title"
              data-aos="fade-right"
            >
              Completed Higher Secondary - Science
            </h3>
            <h4
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
            >
              H B J College, Khajauli, Bihar
            </h4>
            <h4 
              className="vertical-timeline-element-subtitle"
              data-aos="fade-right"
              id="Course"
              > March 2015 </h4>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            icon={<StarRateIcon />}
            iconStyle={{
              backgroundColor: `var(--clr-bg)`,
              color: `var(--clr-primary)`
            }}
          ></VerticalTimelineElement> */}

          
        </VerticalTimeline>

        <Box marginTop={8}>
          <h2 className="section__title" data-aos="fade-right">
            My <span className="different">Education 🎓</span>
          </h2>
        </Box>
        
        <div className="TimeLine" data-aos="fade-right">
        <div className="box">
            <div id="iconSize">
              <IoIosSchool />
            </div>
          </div>
          <div>
            <div className="box">
                <div>
                  <h3
                    className="vertical-timeline-element-title"
                    data-aos="fade-right"
                  >
                    Student
                  </h3>
                </div>
                <div>
                <h4
                  className="vertical-timeline-element-subtitle"
                  data-aos="fade-right"
                >
                  Masai School (Remote)
                </h4>
                </div>
                <div>
                <p 
                  className="vertical-timeline-element-p-subtitle"
                  data-aos="fade-right"
                  id="Course"
                  > April 2022 - Feb 2023 </p>
                </div>
            </div>
          </div>

          {/* college */}

          
          <div>
            <div className="box">
                <div>
                  <h3
                    className="vertical-timeline-element-title"
                    data-aos="fade-right"
                  >
                    B.Sc, Mathematics Honours
                  </h3>
                </div>
                <div>
                <h4
                  className="vertical-timeline-element-subtitle"
                  data-aos="fade-right"
                >
                  D B College, Jainagar
                </h4>
                </div>
                <div>
                <h4 
                  className="vertical-timeline-element-p-subtitle"
                  data-aos="fade-right"
                  id="Course"
                  > 2015 - 2018 </h4>
                </div>
            </div>
          </div>

          <div className="box">
            <div id="iconSize">
              <IoIosSchool />
            </div>
          </div>

          {/* Higher Secondary */}


          <div className="box">
            <div id="iconSize">
              <IoIosSchool />
            </div>
          </div>
          <div>
            <div className="box">
                <div>
                  <h3
                    className="vertical-timeline-element-title"
                    data-aos="fade-right"
                  >
                    Higher Secondary - Science
                  </h3>
                </div>
                <div>
                <h4
                  className="vertical-timeline-element-subtitle"
                  data-aos="fade-right"
                >
                 H B J College, Khajauli, Bihar
                </h4>
                </div>
                <div>
                <h4 
                  className="vertical-timeline-element-p-subtitle"
                  data-aos="fade-right"
                  id="Course"
                  > March 2015 </h4>
                </div>
            </div>
        </div>
        {/* <div>
          <h1>Hello</h1>
        </div> */}
        </div>
      </div>
    </>
  );
};
